module.exports = __webpack_public_path__ + "static/media/antecna-full-logo.d6ac6430.svg";